<template>
  <span fluid>
  <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Enviar Email</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <v-text-field
                    v-model="whats.email"
                    label="Para:"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-text-field
                    v-model="whats.assunto"
                    label="Assunto:"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-textarea
                    v-model="whats.body"
                    label="Corpo:"
                    no-resize
                    rows="2"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn small color="primary" @click="cancelarEmail()">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="enviarEmail()">Enviar email</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <v-flex xs12 sm12 md6>
          <h2>Gerenciamento de Documentos Eletrônicos</h2>
        </v-flex>
        <v-flex xs12 sm12 md2>
          <v-btn @click="onNewButtonClick()" small color="primary">Enviar arquivos</v-btn>
        </v-flex>
        <v-flex xs12 sm12 md2>
          <v-btn @click="zeraDatasClick()" small color="primary">Zera datas</v-btn>
        </v-flex>
        <v-flex xs12 sm12 md2>
          <v-btn @click="filtrarClick()" small color="primary">Filtrar</v-btn>
        </v-flex>
        <v-flex xs12 sm4>
          <v-select
            :items="setor"
            filled
            v-model="item.fk_setor"
            item-text="descricao"
            item-value="id"
            label="Setor"
            @input="onSetorSelect()"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm3>
          <v-select
            :items="tipo_documento"
            filled
            v-model="item.fk_tipo_documento"
            item-text="descricao"
            item-value="id"
            label="Tipo Documento"
            @input="onDocumentoSelect()"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm2>
          <v-text-field
            v-model="item.data_inicio"
            label="Data início"
            type="tel"
            v-mask="'##/##/####'"
            required
            @input="onDataInicio()"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm2>
          <v-text-field
            v-model="item.data_fim"
            label="Data fim"
            type="tel"
            v-mask="'##/##/####'"
            required
            @input="onDataFim()"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm1>
          <v-text-field
            v-model="item.ano"
            label="Ano"
            type="tel"
            v-mask="'####'"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12>
          <v-text-field
            v-model="item.localizarpdf"
            label="Localizar no PDF"
            required
          ></v-text-field>
        </v-flex>
        </v-card-title>
      </v-card>
      <v-card class="card--flex-toolbar" v-if='admin'>
        <v-card-text>
          <e-data-table
            :headers="headers"
            :items="ged"
            :total="total"
            @refresh="getAll"
            @edit="editItem"
            @search="search"
            @email="ativaItem"
            @delete="deleteItem"
          ></e-data-table>
        </v-card-text>
      <v-card-actions></v-card-actions>
      </v-card>
      <v-layout column style="height: 450px">
        <v-flex style="overflow: auto">
          <v-card class="card--flex-toolbar" v-if='pdf'>
            <v-card-text>
              <e-data-table6
                :headers="headers"
                :items="ged1"
                :total="total"
                @refresh="getAll"
                @edit="editItem"
                @search="search"
                @email="ativaItem"
                @delete="deleteItem"
              ></e-data-table6>
            </v-card-text>
            <v-card-actions></v-card-actions>
        </v-card>
        </v-flex>
      </v-layout>
  </span>
</template>
<script>
// import axios from 'axios'
import atualizacaoService from '@/services/atualizacao'
import EDataTable from '@/components/EDataTable'
import EDataTable6 from '@/components/EDataTable6'
import { showError, validateDate } from '@/utils'
import Swal from 'sweetalert2'

export default {
  name: 'equipamentos',
  components: {
    EDataTable,
    EDataTable6
  },
  data () {
    return {
      admin: true,
      pdf: false,
      dtini: '',
      dtfim: '',
      item: {
        data_inicio: '',
        data_fim: '',
        fk_tipo_documento: '',
        fk_setor: '',
        ano: '',
        localizarpdf: ''
      },
      setor: [],
      tipo_documento: [],
      emailId: '',
      emailEndereco: '',
      fotopessoa: '',
      // item: {},
      name: 'teste',
      dialog: false,
      whats: [],
      ged: [],
      ged1: [],
      total: 0,
      headers: [
        { text: 'Data', value: 'data_documento', sortable: false },
        { text: 'Descrição', value: 'descricao', sortable: false },
        { text: 'Setor', value: 'setor', sortable: false },
        { text: 'Documento', value: 'documento', sortable: false },
        { text: 'Resumo', value: 'resumo', sortable: false }],
      valid: true,
      buttonSaveLoadingVisible: false
    }
  },
  async mounted () {
    try {
      this.setor = []
      this.tipo_documento = []
      const s = await atualizacaoService.getSetorTodos()
      if (s.data !== undefined) {
        this.setor = s.data
      }
      const d = await atualizacaoService.getDocumentoTodos()
      if (d.data !== undefined) {
        this.tipo_documento = d.data
      }
      this.item.fk_setor = 0
      this.item.fk_tipo_documento = 0
      this.item.dtini = ''
      this.item.dtfim = ''
      // this.loading = false
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    filtrarClick () {
      if (this.item.fk_setor === '') {
        showError('Selecione setor')
        return
      }
      if (this.item.fk_tipo_documento === '') {
        showError('Selecione tipo de documento')
        return
      }
      if (this.item.ano.length > 0 && this.item.ano.length < 4) {
        showError('Ano inválido')
        return
      }
      if (this.item.ano.length > 0 && this.item.data_inicio.length > 0 && this.item.data_fim.length > 0) {
        showError('Selecione período ou ano')
        return
      }
      if (this.item.ano === '') {
        if (this.item.data_inicio.length > 0 || this.item.data_fim.length > 0) {
          var ret = validateDate(this.item.data_inicio)
          if (ret === false) {
            showError('Data início inválida')
            this.item.data_inicio = ''
            return
          }
          var ret1 = validateDate(this.item.data_fim)
          if (ret1 === false) {
            showError('Data fim inválida')
            this.item.data_fim = ''
            return
          }
          var dia = this.item.data_inicio.substr(0, 2)
          var mes = this.item.data_inicio.substr(3, 2)
          var ano = this.item.data_inicio.substr(6, 4)
          var dia1 = this.item.data_fim.substr(0, 2)
          var mes1 = this.item.data_fim.substr(3, 2)
          var ano1 = this.item.data_fim.substr(6, 4)
          this.dtini = ano + mes + dia
          this.dtfim = ano1 + mes1 + dia1
          if (this.dtfim < this.dtini) {
            showError('Data início maior que data fim')
            return
          }
          this.dtini = ano + '-' + mes + '-' + dia
          this.dtfim = ano1 + '-' + mes1 + '-' + dia1
        } else {
          this.dtini = '@'
          this.dtfim = '@'
        }
      } else {
        this.dtini = '@'
        this.dtfim = '@'
      }
      if (this.item.ano.length === 0) {
        this.item.ano = '@'
      }
      this.getAll()
    },
    async onDataInicio () {
      try {
        if (this.item.data_inicio.length === 10) {
          var ret = validateDate(this.item.data_inicio)
          if (ret === false) {
            showError('Data início inválida')
            this.item.data_inicio = ''
          }
        }
      } catch (error) {
        showError(error)
      } finally {
        // this.ultimoLancamentoLoadingIsVisible = false
      }
    },
    async onDataFim () {
      try {
        if (this.item.data_fim.length === 10) {
          var ret = validateDate(this.item.data_fim)
          if (ret === false) {
            showError('Data fim inválida')
            this.item.data_fim = ''
          }
        }
      } catch (error) {
        showError(error)
      } finally {
        // this.ultimoLancamentoLoadingIsVisible = false
      }
    },
    async deleteItem (item) {
      Swal.fire({
        title: 'Deseja excluir ' + item.descricao + ' ?',
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: 'Sim',
        confirmButtonColor: '#3085d6',
        denyButtonText: 'Não'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.deletando(item)
        }
      })
    },
    async deletando (item) {
      try {
        await atualizacaoService.delete(item.id)
        this.getAll()
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    },
    async onSetorSelect () {
    // this.getAll()
    },
    async onDocumentoSelect () {
    // this.getAll()
    },
    selecionarClick () {
      this.dialog = false
    },
    async getAll (page, search) {
      if (this.item.fk_setor === '') {
        return
      }
      if (this.item.fk_tipo_documento === '') {
        return
      }
      if (this.dtini.length === 0) {
        this.dtini = '@'
      }
      if (this.dtfim.length === 0) {
        this.dtfim = '@'
      }
      if (this.item.ano.length === 0) {
        this.item.ano = '@'
      }
      if (search === undefined || search === '') {
        this.loading = false
        search = ' '
      }
      var lpdf = ''
      if (this.item.localizarpdf.length > 0) {
        lpdf = this.item.localizarpdf
        this.admin = false
        this.pdf = true
        if (this.dtini === '@' && this.dtfim === '@' && this.item.ano === '@') {
          this.item.ano = ''
          showError('Selecione um período ou ano')
          return
        }
      } else {
        lpdf = '@'
        this.admin = true
        this.pdf = false
      }
      try {
        this.ged = []
        this.ged1 = []
        // const result = await atualizacaoService.getById(this.dataPicker, this.dataPicker1, this.item.fk_setor, this.item.fk_tipo_documento, search, page)
        const result = await atualizacaoService.getById(this.item.ano, this.dtini, this.dtfim, this.item.fk_setor, this.item.fk_tipo_documento, search, lpdf, page)
        if (result.data === undefined) {
          showError('Não localizei dados')
          return
        }
        if (result.data[0].erro === 'S') {
          showError(result.data[0].path + ': ' + result.data[0].arquivo)
          return
        }
        // this.ged1 = result.data
        // if (lpdf === '@') {
        // return
        // }
        if (lpdf === '@') {
          this.total = result._meta.total_items
          this.ged = result.data
        } else {
          this.ged1 = result.data
        }
        // this.ged = result.data
        if (this.dtini === '@') {
          this.dtini = ''
        }
        if (this.dtfim === '@') {
          this.dtfim = ''
        }
        if (this.item.ano === '@') {
          this.item.ano = ''
        }
      } catch (error) {
        this.ged = []
        showError(error)
      }
    },
    async search (item) {
      try {
        // this.dialog = true
        // this.$router.push(`/ged/editar/${item.id}`)
        // this.loading = true
        var id = item.id
        const result = await atualizacaoService.getPdf(id)
        if (result[0].erro === 'S') {
          showError(result[0].path)
        } else {
          window.open(result[0].path)
        }
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    },
    editItem (item) {
      this.$router.push(`/ged/editar/${item.id}`)
    },
    async cancelarEmail () {
      this.dialog = false
    },
    async ativaItem (item) {
      // Swal.fire({
      // title: 'Item em desenvolvimento',
      // confirmButtonText: 'OK',
      // confirmButtonColor: '#3085d6'
      // }).then((result) => {})
      // return
      this.emailId = item.id
      this.dialog = true
    },
    validateEmail (email) {
      var re = /\S+@\S+\.\S+/
      return re.test(email)
    },
    async enviarEmail () {
      try {
        if (this.validateEmail(this.whats.email) === false) {
          Swal.fire({
            title: 'Email inválido',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6'
          }).then((result) => {})
          return
        }
        if (this.whats.assunto === undefined) {
          Swal.fire({
            title: 'Assunto inválido',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6'
          }).then((result) => {})
          return
        }
        if (this.whats.body === undefined) {
          Swal.fire({
            title: 'Corpo inválido',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6'
          }).then((result) => {})
          return
        }
        // if (this.validateEmail(this.whats.email)) {
        // }
        // this.dialog = true
        // this.$router.push(`/ged/editar/${item.id}`)
        // this.loading = true
        // var id = item.id
        // var email = this.whats.email
        // var email = 'james.rogerio19@gmail.com'
        const result = await atualizacaoService.getEmail(this.emailId, this.whats.email, this.whats.assunto, this.whats.body)
        if (result[0].erro === 'S') {
          Swal.fire({
            title: 'Erro ao enviar email: ' + result[0].path,
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6'
          }).then((result) => {})
          this.dialog = false
        } else {
          Swal.fire({
            title: 'Email enviado com sucesso',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6'
          }).then((result) => {})
          this.dialog = false
        }
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    },
    onNewButtonClick () {
      this.$router.push(`/ged/criar`)
    },
    zeraDatasClick () {
      this.item.data_inicio = ''
      this.item.data_fim = ''
      this.item.ano = ''
      this.getAll()
    }
  }
}
</script>
<style scoped>
.flex{
    height: 50px;
  }
</style>
